import publicConfig from "config/public";
import { useSelector } from "react-redux";

import { getDomainCountryCode } from "redux/selectors/config";

const { leaflyDomain, leaflyCaDomain } = publicConfig;

export const getDomainFromContext = (countryCode: string) =>
  countryCode === "CA" ? leaflyCaDomain : leaflyDomain;

const useDomain = () => getDomainFromContext(useSelector(getDomainCountryCode));

export default useDomain;
